import { render, staticRenderFns } from "./MergeAliasDialog.vue?vue&type=template&id=cf8b724a"
import script from "./MergeAliasDialog.vue?vue&type=script&lang=js"
export * from "./MergeAliasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports